import { gravParam, HOME_PLANET, type PlanetSpec } from "./planets";
import type { Planet, Vec2, World } from "./types";

/** Builds the runtime planet from a spec (defaults to the home planet). */
export function makePlanet(spec: PlanetSpec = HOME_PLANET): Planet {
  return {
    pos: { x: 0, y: 0 },
    radiusM: spec.radiusM,
    gravParam: gravParam(spec),
  };
}

/** Circular-orbit speed at radius `r` from the planet centre: v = √(μ / r). */
export function orbitalSpeed(planet: Planet, r: number): number {
  return Math.sqrt(planet.gravParam / r);
}

/** Newtonian point-mass gravity, applied to every orbiting body's velocity.
 *  Call once per tick before the physics integration step. */
export function applyGravity(world: World, dt: number): void {
  const p = world.planet;
  for (const ship of world.ships.values()) {
    pullToward(p, ship.body.pos, ship.body.vel, dt);
  }
  for (const it of world.items.values()) {
    pullToward(p, it.pos, it.vel, dt);
  }
}

function pullToward(p: Planet, pos: Vec2, vel: Vec2, dt: number): void {
  const dx = p.pos.x - pos.x;
  const dy = p.pos.y - pos.y;
  const r2 = dx * dx + dy * dy;
  if (r2 < 1) return;
  const r = Math.sqrt(r2);
  const a = p.gravParam / r2;
  vel.x += a * (dx / r) * dt;
  vel.y += a * (dy / r) * dt;
}
